// Projects data.
// Note: Here we are getting data from a js file, but in a different project I'll be fetching these projects from some srt of APIs.

const projects = [
	{
		id: 1,
		title: 'Kotonaru - Online Long-term Internship',
		category: 'Full Stack Development',
		img: require('@/assets/images/projects/kotonaru/Kotonaru_Top.png'),
	},
	{
		id: 2,
		title: 'Crosspoint - Restaurant Financial Management',
		category: 'Full Stack Development',
		img: require('@/assets/images/projects/crosspoint/Crosspoint_Top.png'),
	},
	{
		id: 3,
		title: 'Sabi Jobs - Job Search Application',
		category: 'UI and Front-End Development',
		img: require('@/assets/images/projects/sabi/Sabi_Top.png'),
	},
	{
		id: 4,
		title: 'KASPZ proforma generator and Inventory Management',
		category: 'Front-End Development',
		img: require('@/assets/images/projects/kaspz/Kaspz_Top.png'),
	},
	// {
	// 	id: 5,
	// 	title: 'React Social App',
	// 	category: 'Mobile Application',
	// 	img: require('@/assets/images/mobile-project-1.jpg'),
	// },
	// {
	// 	id: 6,
	// 	title: 'Apple Design System',
	// 	category: 'Web Application',
	// 	img: require('@/assets/images/web-project-1.jpg'),
	// },
];

export default projects;
